// extracted by mini-css-extract-plugin
module.exports = {"iconCol":"oqJftQ","iconColWhite":"_3iYPPb","wrapper":"A6bnk5"};